"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketItem = MarketItem;
exports.MarketSelector = MarketSelector;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MarketSelectorContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MarketSelectorContainer",
  class: "pl-mb0zqx4"
});
const MarketItemContainer = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "MarketItemContainer",
  class: "pl-mtzrfhg",
  vars: {
    "mtzrfhg-0": [props => props.selected ? 'underline' : 'none'],
    "mtzrfhg-1": [props => props.selected ? '#00a4a6' : _intents.default.ux.box.foregroundColor]
  }
});
const MarketList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MarketList",
  class: "pl-mdqpyun"
});
const Tray = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Tray",
  class: "pl-t1jshw8k"
});
const TrayToggleWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayToggleWrapper",
  class: "pl-t1swrl5s"
});
const TrayToggle = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "TrayToggle",
  class: "pl-t3f7h8t",
  vars: {
    "t3f7h8t-2": [props => props.trayOpen ? 'rotate(180deg)' : 'rotate(0deg)']
  }
});
const TrayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayContent",
  class: "pl-thet9ht"
});
const Header = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Header",
  class: "pl-hd0orj8"
});

/**
 * Market Selector Item Component
 *
 * @param {Object} props React props
 * @param {string} props.id id
 * @param {string} props.path path (localized page path)
 * @param {string} props.url url (url inlcuding the market path)
 * @param {Object} props.description Description of the market
 * @param {boolean} [props.selected=false] Item is selected currency
 * @returns {React.ReactElement} Market Item button
 * @public
 */
function MarketItem({
  id,
  url,
  path = '',
  description,
  selected = false,
  pcgoUrl
}) {
  const marketArray = description.split('-');
  const countryName = marketArray[0];
  const languageName = marketArray[1];

  // eslint-disable-next-line max-statements
  const setMarket = e => {
    e.preventDefault();
    const {
      host,
      pathname,
      search
    } = window.location;
    const domain = host.substring(host.indexOf('.') + 1);
    const date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `currency=;domain=${domain};path=/;${expires}`;
    document.cookie = `market=${id};domain=${domain};path=/;${expires}`;
    if (path && path !== '/') {
      window.location.href = url + path;
    } else {
      const queryString = search.length > 1 ? `&${search.substring(1)}` : '';
      const currentPath = pathname.replace(/^\/[a-zA-Z]{2}(?=\/|$)/, '');
      const newUrl = `${pcgoUrl}/${currentPath}?marketid=${id}${queryString}`;
      window.location.href = newUrl;
    }
  };
  return /*#__PURE__*/_react.default.createElement(MarketItemContainer, {
    selected: selected,
    "data-cy": "market-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: url + path,
    "data-market": id,
    onClick: setMarket
  }, /*#__PURE__*/_react.default.createElement("strong", null, countryName), " - ", languageName));
}
MarketItem.propTypes = {
  id: _propTypes.default.string,
  url: _propTypes.default.string,
  path: _propTypes.default.string,
  description: _propTypes.default.string,
  selected: _propTypes.default.bool,
  pcgoUrl: _propTypes.default.string
};

/**
 * Footer Controls component.
 *
 * @param {Object} props React props
 * @param {string} id ID for market selector
 * @param {string} props.header Header string
 * @param {string} props.ariaLabel Aria Label
 * @param {Array} props.marketList Market list
 * @param {Object} props.selectedMarket Current market
 * @returns {React.ReactElement} Market Selector component
 * @public
 */
function MarketSelector({
  id,
  header,
  ariaLabel,
  marketList,
  selectedMarket,
  pcgoUrl
}) {
  const [trayOpen, setTrayOpen] = (0, _react.useState)(false);
  const selector = (0, _react.useRef)(null);
  const exitOnEscape = ({
    keyCode
  }) => {
    if (keyCode === 27) {
      setTrayOpen(false);
    }
  };
  const exitOnClick = ({
    target
  }) => {
    if (selector.current && !selector.current.contains(target)) {
      setTrayOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', exitOnEscape, false);
      document.addEventListener('mousedown', exitOnClick, false);
      return () => {
        document.removeEventListener('keydown', exitOnEscape, false);
        document.removeEventListener('mousedown', exitOnClick, false);
      };
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(MarketSelectorContainer, {
    id: `id-${id}`,
    tabIndex: "-1",
    ref: selector,
    "data-cy": "market-selector"
  }, /*#__PURE__*/_react.default.createElement(TrayToggleWrapper, null, /*#__PURE__*/_react.default.createElement(TrayToggle, {
    id: "currentMarket",
    tabIndex: "0",
    "aria-label": ariaLabel.replace('{market}', selectedMarket.description),
    "aria-haspopup": "true",
    type: "button",
    "aria-expanded": trayOpen,
    trayOpen: trayOpen,
    onClick: () => setTrayOpen(!trayOpen),
    onKeyPress: e => {
      e.preventDefault();
      if (e.key === 'Enter') {
        setTrayOpen(!trayOpen);
      }
    }
  }, selectedMarket.description, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-up",
    fill: "white"
  }))), /*#__PURE__*/_react.default.createElement(Tray, {
    tabIndex: "-1",
    className: trayOpen ? 'open' : 'close'
  }, /*#__PURE__*/_react.default.createElement(TrayContent, null, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: () => setTrayOpen(false)
  }), /*#__PURE__*/_react.default.createElement(Header, null, header), /*#__PURE__*/_react.default.createElement(MarketList, null, marketList?.sort((a, b) => {
    a.description.localeCompare(b.description);
  })?.map((market, i) => /*#__PURE__*/_react.default.createElement(MarketItem, (0, _extends2.default)({}, market, {
    selected: market.id === selectedMarket.id,
    key: i,
    pcgoUrl: pcgoUrl
  })))))));
}
MarketSelector.propTypes = {
  id: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  header: _propTypes.default.string,
  marketList: _propTypes.default.array,
  selectedMarket: _propTypes.default.object,
  pcgoUrl: _propTypes.default.string
};